<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>Acompanhar acordo</h1>
    </div>

    <app-informacoes-cartao 
      [nomeProduto]="acordo?.nomeProduto || ''"
      [debtValue]="acordo?.valorAcordo || 0" 
      [customerName]="contato?.nome || ''"
      [numeroCartaoMascarado]="mascararNumeroCartao(acordo?.idCartao || '')">
    </app-informacoes-cartao>
    
    <app-acordo-table [parcelas]="parcelasAcordo" [acordoAvista]="acordo?.tipoPlano === TipoPlanoRenegociacaoCartao.A_VISTA" (onEmitirBoleto)="handleEmitirBoleto($event)">
    </app-acordo-table>
  </div>
</section>